import { useEffect, useRef, useState } from "react";
import { Button, Container, FloatingLabel, Form, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Column, Icon, Panel, Select } from "../../../../components";
import { useConfirmationModalContext } from "../../../../shared/components/ModalConfirmationContext";
import { RootState } from "../../../../shared/store";
import * as constant from '../../../../shared/util/constant';
import { CustomerScreentLables as cstScrLables } from "../../../../shared/util/label";
import { CustomerPolicyDetailLabels as cstPolicyDetailLabel } from '../../../../shared/util/label';
import CustomerDetailService from "../../../customer-details/CustomerDetailService";
import { updateCustomers, updateSelectedPolicyDetails } from "../../../customer-slice/Customer-slice";
import CustomerInsuredName from "../../../model/CustomerInsuredName";
import './CustomerInsuredName.scss';
import { toast } from "react-toastify";
import { CommonUtility } from "../../../../Services/CommonUtility";
import { uuid } from "../../../../shared/util/uuid";
import { InputMask } from "primereact/inputmask";
import PreviousAddress from "../../../model/PreviousAddress";
import TextInputWithZipCode from "../../../../shared/components/input/TextInputWithZipCode";
import { SelectOption } from "../../../../shared/components/input";
import LookupService from "../../../../Services/LookupService";
import { updateLookupData } from "../../../customer-slice/Customer-lookup-slice";
import { LookupData } from "../../../../Models/LoookupData";

type CountryOption = SelectOption & { countryCode: string };

const mapCountryToSelectOptions = (lookupData: LookupData[]): CountryOption[] =>
    lookupData?.map(item => ({ label: item.lookupValue, value: item.id, countryCode: item.lookupCode, isInactive: item.inactive }));


export interface ICustomerInsuredName {
    customerId: string;
    validationErrors?: any;
    tabIndex?: number;
}

const CustomerInsured: React.FunctionComponent<ICustomerInsuredName> = (props) => {
     const { validationErrors } = props;
     let tbindex = props.tabIndex;
    // Get policyId and polEventId from Redux
    const { policyId, polEventId } = useSelector((state: RootState) => ({
        policyId: state.customerSlice.policyId,
        polEventId: state.customerSlice.polEventId
    }));
    const dispatch = useDispatch()

    const customerDetailService = new CustomerDetailService();

    const policyDetailKey = CommonUtility.getPolicyDetailKey(policyId, polEventId);
    
    const customerpolicyDetail = useSelector((state: RootState) => state?.customerSlice);

    const policyDetails = customerpolicyDetail.selectedPolicyDetails?.[policyDetailKey];

    const insured = policyDetails?.policyInsureds?.[0] || {};

    const previousAddress = policyDetails?.policyPreviousAddress?.[0] || {};

    const [formValidation, setFormValidation] = useState<any>({});

    // Set validation errors from props to formValidation state
    useEffect(() => {
        if (validationErrors) {
            setFormValidation(validationErrors);
        }
    }, [validationErrors]);

    //Form control constant here
    const [isEditable, setIsEditable] = useState(true);
    const contactInoLg = 4;
    const contactInoMd = 4;
    const contactInoLg8 = 8;
    const contactInoMd8 = 8;
    const modalContext = useConfirmationModalContext();
    const firstNameRef = useRef(null)
    const addContactButtonRef = useRef(null);
    //Ends here

    let customerInfo = useSelector((state: RootState) => state?.customerSlice);
    let stateUSLookup = useSelector((state: RootState) => state?.LookupState.stateUSList);
    let countryLookup = useSelector((state: RootState) => state?.LookupState.countryList);
    const states = [...stateUSLookup];

    const [countries, setCountries] = useState<CountryOption[]>([]);
    const addressCountry = insured.mailCountryCode || customerInfo.customer?.countryId || constant.DATA_IDs.COUNTRIES.USA;
    const selectedCountry = countries.find(option =>
        option.countryCode === addressCountry || option.value === addressCountry
    );
    const countryId = selectedCountry?.value || addressCountry;
    const isMailUSA = countryId === constant.DATA_IDs.COUNTRIES.USA;

    // The policy screen only preloads US states, so mailing-address lookups are fetched on demand.
    useEffect(() => {
        const loadMailingLookups = async () => {
            const countryData = await LookupService.fetchCountries();
            if (countryData?.length > 0) {
                const countryOptions = mapCountryToSelectOptions(countryData);
                setCountries(countryOptions);
                dispatch(updateLookupData({ data: countryOptions, type: constant.SlicerLookUpConstant.COUNTRY }));
            } else if (countryLookup?.length > 0) {
                setCountries(countryLookup.map(option => ({ ...option, countryCode: option.value })));
            }
        };
        loadMailingLookups();
    }, []);

    const mapCustomerToFirstNameIsured = (data: any) => {
        const customerCountry = data.countryId || constant.DATA_IDs.COUNTRIES.USA;
        const country = countries.find(option => option.value === customerCountry);
        let detail: CustomerInsuredName = {
            ...(policyDetails?.policyInsureds?.[0] ?? defaultInsured),
            mailCountryCode: country?.countryCode || customerCountry,
            mailIsForeign: customerCountry !== constant.DATA_IDs.COUNTRIES.USA,
            firstName: data.firstName,
            lastName: data.lastName,
            midName: data.midName,
            homePhone: data.homePhone,
            workPhone: data.workPhone,
            mobile: data.mobile,
            eMail: data.eMail,
            mailCounty: data.county,
            mailAddr1: data.address1,
            mailAddr2: data.address2,
            mailCity: data.city,
            mailState: data.state,
            mailZip: data.zipCode,
            otherPhone1: data.otherPhone1,
            otherPhone2: data.otherPhone2,
            email2: data.eMail2,
            email3: data.email3,
            decNameApp : data.displayName
        };
        if (policyDetails) {
            const updatedInsureds = [...(policyDetails.policyInsureds || [{}])];
            updatedInsureds[0] = detail;
            const updatedPolicyDetails = { ...policyDetails, policyInsureds: updatedInsureds };
            dispatch(updateSelectedPolicyDetails({
                policyId,
                polEventId,
                policyDetails: updatedPolicyDetails,
            }));
        }
    }

    const defaultInsured: CustomerInsuredName = {
        polId: policyId,
        polEventId: polEventId,
        id: uuid(),
        effDate: new Date()
    };

    const onEntityFieldChange = (propName: string, value: string | Date | boolean) => {
        if (policyDetails) {
            const updatedInsureds = [...(policyDetails.policyInsureds && policyDetails.policyInsureds.length > 0 ? policyDetails.policyInsureds : [defaultInsured])];
            updatedInsureds[0] = { ...updatedInsureds[0], [propName]: value };
           
            if (propName == 'firstName' || propName == 'lastName') {
                updatedInsureds[0] = { ...updatedInsureds[0], 
                decNameApp:  (updatedInsureds[0].firstName ? updatedInsureds[0].firstName : '') + ' ' + (updatedInsureds[0].lastName ? updatedInsureds[0].lastName : '') };           
            }

            const updatedPolicyDetails = { ...policyDetails, policyInsureds: updatedInsureds };
            dispatch(updateSelectedPolicyDetails({
                policyId,
                polEventId,
                policyDetails: updatedPolicyDetails,
            }));
        }
    };

    const onInsuredFieldsChange = (changes: Partial<CustomerInsuredName>) => {
        if (policyDetails) {
            const updatedInsureds = [...(policyDetails.policyInsureds && policyDetails.policyInsureds.length > 0 ? policyDetails.policyInsureds : [defaultInsured])];
            updatedInsureds[0] = { ...updatedInsureds[0], ...changes };

            const updatedPolicyDetails = { ...policyDetails, policyInsureds: updatedInsureds };
            dispatch(updateSelectedPolicyDetails({
                policyId,
                polEventId,
                policyDetails: updatedPolicyDetails,
            }));
        }
    };

    const onMailCountrySelection = (countrySelected: string) => {
        const selectedCountry = countries.find(option => option.value === countrySelected);
        const countryCode = selectedCountry?.countryCode || countrySelected;
        onInsuredFieldsChange({
            mailCountryCode: countryCode,
            mailIsForeign: countrySelected !== constant.DATA_IDs.COUNTRIES.USA,
            mailState: "",
            mailZip: "",
        });
        setFormValidation({
            ...formValidation,
            mailState: { isValid: true, warningText: '' },
            mailZip: { isValid: true, warningText: '' },
            resZip: { isValid: true, warningText: '' },
            zip: { isValid: true, warningText: '' },
        });
    };

    useEffect(() => {
        const countryCode = insured.mailCountryCode || customerInfo.customer?.countryId
            ? selectedCountry?.countryCode || addressCountry
            : insured.mailCountryCode;
        if (policyDetails && (insured.mailCountryCode !== countryCode || insured.mailIsForeign !== !isMailUSA)) {
            onInsuredFieldsChange({ mailCountryCode: countryCode, mailIsForeign: !isMailUSA });
        }
    }, [policyDetails, addressCountry, selectedCountry, isMailUSA, customerInfo.customer?.countryId]);

    const mapCustomerToPreviousAddress = (data: any) => {
        let detail: PreviousAddress = {
            ...defaultPreviousAddress,
            address1: data.address1,
            address2: data.address2,
            city: data.city,
            state: data.state,
            zip: data.zip,
            yearsPrevAddress: data.yearsPrevAddress,
        };
        if (policyDetails) {
            const updatedPrevAdds = [...(policyDetails.policyPreviousAddress || [{}])];
            updatedPrevAdds[0] = detail;
            const updatedPolicyDetails = { ...policyDetails, policyPreviousAddress: updatedPrevAdds };
            dispatch(updateSelectedPolicyDetails({
                policyId,
                polEventId,
                policyDetails: updatedPolicyDetails,
            }));
        }
    }

    const defaultPreviousAddress: PreviousAddress = {
        polId: policyId,
        polEventId: polEventId,
        id: uuid(),
        effDate: new Date(),
    };

    const onEntityFieldChangeForPrevAdd = (propName: string, value: string | Date | boolean | Number) => {
        if (policyDetails) {
            const updatedPrevAdds = [...(policyDetails.policyPreviousAddress && policyDetails.policyPreviousAddress.length > 0 ? policyDetails.policyPreviousAddress : [defaultPreviousAddress])];
            updatedPrevAdds[0] = { ...updatedPrevAdds[0], [propName]: value };

            const updatedPolicyDetails = { ...policyDetails, policyPreviousAddress: updatedPrevAdds };
            dispatch(updateSelectedPolicyDetails({
                policyId,
                polEventId,
                policyDetails: updatedPolicyDetails,
            }));
        }
    };

    // const handleChangeZipCodeOnBlur = (propName: string, val: string) => {
    //     if (val) {
    //         let validationErrors = customerDetailService.validationForZipCode(propName, val)
    //         if (validationErrors) {
    //             setFormValidation(validationErrors)
    //         } else { setFormValidation(0); }
    //     }
    // };

    const updateCustomerData = async () => {
        // Always fetch fresh customer data from API to ensure data is in sync
        let customerData = await customerDetailService.fetchCustomerById(props.customerId);
        dispatch(updateCustomers(customerData));
        mapCustomerToFirstNameIsured(customerData);
        // mapCustomerToPreviousAddress(customerData);
        
        toast.success(constant.CUSTOMER_UPDATE_BUTTON_SUCCESS, {
            position: toast.POSITION.TOP_RIGHT
        });
    }
    // const tooltip = (
    //     <Tooltip id="tooltip"> {constant.ZIPCODE_TOOLTIP} </Tooltip>
    // );
    //Ends here

    //Button controls start here
    const UpdateFromCustomer = async () => {
        setFormValidation(0)
        setIsEditable(true)
        updateCustomerData();
    }
    //Ends here

    const handleChangeZipCodeOnBlur = (propName: string, val: string, isUSA?: boolean) => {
        if (val) {
            let validationErrors = customerDetailService.validationForZipCode(propName, val, isUSA)
            if (Object.keys(validationErrors).length > 0) {
                setFormValidation({ ...formValidation, ...validationErrors })
            } else {
                const newObject = { ...formValidation };
                delete newObject[propName];
                setFormValidation(newObject);
            }
        }
    };


    return (
        <>
            <Container fluid>
                <Row >
                    <Column md={12}>
                        <Button
                            variant="outline-primary"
                            onClick={() => UpdateFromCustomer()}
                            tabIndex={tbindex++}
                            id="btnCancel"
                            disabled={!isEditable}
                            style={{ minWidth: "90px" }}
                            className="me-2">
                            {cstPolicyDetailLabel.UPDATE_FROM_CUSTOMER}
                        </Button>
                        <Panel title={'Customer Information'} className={'customerPanel cstPanel customerOverview mt-2'} cardBodyClassName="pt-0" collapsible={false}>
                            <Row className="border-top">
                                <Column lg={12} md={12} className="section-height customer-edit-policy-column">
                                    <Row>
                                        <Column lg={contactInoLg} md={contactInoMd} className={formValidation['firstName']?.isValid == false ? 'feedback-row' : ''}>
                                            <FloatingLabel controlId="firstName"
                                                label={<>{cstScrLables.FIRST_NAME}<span className="text-danger ms-1">*</span></>}
                                                className="mb-3" >
                                                <Form.Control
                                                    type="text"
                                                    tabIndex={tbindex++}
                                                    placeholder={cstScrLables.FIRST_NAME}
                                                    name="firstName"
                                                    ref={firstNameRef}
                                                    value={insured.firstName ?? ""}
                                                    onChange={(event) => onEntityFieldChange('firstName', event.currentTarget.value)}
                                                    disabled={!isEditable}
                                                    required={true}
                                                    maxLength={60}
                                                    isInvalid={formValidation['firstName']?.isValid == false}
                                                />
                                                {formValidation['firstName']?.isValid == false && (
                                                    <Form.Control.Feedback type="invalid">
                                                        {formValidation['firstName']?.warningText}
                                                    </Form.Control.Feedback>
                                                )}
                                            </FloatingLabel>
                                        </Column>
                                        <Column lg={contactInoLg} md={contactInoMd}>
                                            <FloatingLabel
                                                controlId="midName"
                                                label={cstScrLables.MIDDLE_NAME}
                                                className="mb-3"
                                            >
                                                <Form.Control
                                                    type="text"
                                                    placeholder=" "
                                                    name="midName"
                                                    value={insured.midName ?? ""}
                                                    onChange={(event) => onEntityFieldChange('midName', event.currentTarget.value)}
                                                    disabled={!isEditable}
                                                    tabIndex={tbindex++}
                                                    maxLength={60}
                                                />
                                            </FloatingLabel>
                                        </Column>
                                        <Column lg={contactInoLg} md={contactInoMd}
                                            className={formValidation['lastName']?.isValid == false ? 'feedback-row' : ''}>
                                            <FloatingLabel controlId="lastName"
                                                label={<>{cstScrLables.LAST_NAME}<span className="text-danger ms-1">*</span></>}
                                                className="mb-3"                                            >
                                                <Form.Control
                                                    type="text"
                                                    placeholder={cstScrLables.LAST_NAME}
                                                    name="lastName"
                                                    value={insured.lastName ?? ""}
                                                    onChange={(event) => onEntityFieldChange('lastName', event.currentTarget.value)}
                                                    disabled={!isEditable}
                                                    required
                                                    maxLength={60}
                                                    tabIndex={tbindex++}
                                                    isInvalid={formValidation['lastName']?.isValid == false}
                                                />
                                                {formValidation['lastName']?.isValid == false && (
                                                    <Form.Control.Feedback type="invalid">
                                                        {formValidation['lastName']?.warningText}
                                                    </Form.Control.Feedback>
                                                )}
                                            </FloatingLabel>
                                        </Column>
                                    </Row>
                                </Column>
                            </Row>
                            <Row>
                                <Column lg={12} md={12} className="section-height">
                                    <Row>
                                        <Column lg={contactInoLg8} md={contactInoMd8} className={formValidation['declarationName']?.isValid == false ? 'feedback-row' : ''}>
                                            <FloatingLabel controlId="declarationName"
                                                label={cstScrLables.DECLARATIONNAME}
                                                className="mb-3" >
                                                <Form.Control
                                                    type="text"
                                                    placeholder={cstScrLables.DECLARATIONNAME}
                                                    name="declarationName"
                                                    value={insured.decNameApp ?? ""}
                                                    onChange={(event) => onEntityFieldChange('decNameApp', event.currentTarget.value)}
                                                    maxLength={60}
                                                    isInvalid={formValidation['declarationName']?.isValid == false}
                                                    tabIndex={tbindex++}
                                                />
                                                {formValidation['declarationName']?.isValid == false && (
                                                    <Form.Control.Feedback type="invalid">
                                                        {formValidation['declarationName']?.warningText}
                                                    </Form.Control.Feedback>
                                                )}
                                            </FloatingLabel>
                                        </Column>
                                        
                                    </Row>
                                </Column>
                                </Row>
                                <Row>
<Column lg={contactInoLg} md={contactInoMd}
                                            className={formValidation['eMail']?.isValid == false ? 'feedback-row' : ''}>
                                            <div className="input-group has-validation">
                                                <span className="input-group-text remove-right-radius mb-3">
                                                    <Icon icon="email" className="text-muted fa-fw" />
                                                </span>
                                                <FloatingLabel controlId="eMail"
                                                    label={<>{cstScrLables.EMAIL}</>}
                                                    className="mb-3">
                                                    <Form.Control
                                                        type="text"
                                                        placeholder={cstScrLables.NO_OF_MEMBERS}
                                                        name="email"
                                                        value={insured.eMail ?? ""}
                                                        onChange={(event) => onEntityFieldChange('eMail', event.currentTarget.value)}
                                                        disabled={!isEditable}
                                                        tabIndex={tbindex++}
                                                        maxLength={100}
                                                        isInvalid={formValidation['eMail']?.isValid == false}
                                                    />
                                                    {formValidation['eMail']?.isValid == false && (
                                                        <Form.Control.Feedback type="invalid">
                                                            {formValidation['eMail']?.warningText}
                                                        </Form.Control.Feedback>
                                                    )}
                                                </FloatingLabel>
                                            </div>
                                        </Column>
                                        <Column lg={contactInoLg} md={contactInoMd}
                                                className={formValidation['email2']?.isValid == false ? 'feedback-row' : ''}>
                                                <div className="input-group has-validation">
                                                    <span className="input-group-text remove-right-radius mb-3">
                                                        <Icon icon="email" className="text-muted fa-fw" />
                                                    </span>
                                                    <FloatingLabel controlId="email2"
                                                        label={<>{cstScrLables.EMAIL_2}</>}
                                                        className="mb-3">
                                                        <Form.Control
                                                            type="text"
                                                            placeholder={cstScrLables.EMAIL_2}
                                                            tabIndex={tbindex++}
                                                            name="email2"
                                                            value={insured.email2 ?? ""}
                                                            onChange={(event) => onEntityFieldChange('email2', event.currentTarget.value)}
                                                            disabled={!isEditable}
                                                            // required
                                                            maxLength={100}
                                                            isInvalid={formValidation['email2']?.isValid == false}
                                                        />
                                                        {formValidation['email2']?.isValid == false && (
                                                            <Form.Control.Feedback type="invalid">
                                                                {formValidation['email2']?.warningText}
                                                            </Form.Control.Feedback>
                                                        )}
                                                    </FloatingLabel>
                                                </div>
                                            </Column>
                                            <Column lg={contactInoLg} md={contactInoMd}
                                                className={formValidation['email3']?.isValid == false ? 'feedback-row' : ''}>
                                                <div className="input-group has-validation">
                                                    <span className="input-group-text remove-right-radius mb-3">
                                                        <Icon icon="email" className="text-muted fa-fw" />
                                                    </span>
                                                    <FloatingLabel controlId="email3"
                                                        label={<>{cstScrLables.EMAIL_3}</>}
                                                        className="mb-3">
                                                        <Form.Control
                                                            type="text"
                                                            placeholder={cstScrLables.EMAIL_3}
                                                            tabIndex={tbindex++}
                                                            name="email3"
                                                            value={insured.email3 ?? ""}
                                                            onChange={(event) => onEntityFieldChange('email3', event.currentTarget.value)}
                                                            disabled={!isEditable}
                                                            // required
                                                            maxLength={100}
                                                            isInvalid={formValidation['email3']?.isValid == false}
                                                        />
                                                        {formValidation['email3']?.isValid == false && (
                                                            <Form.Control.Feedback type="invalid">
                                                                {formValidation['email3']?.warningText}
                                                            </Form.Control.Feedback>
                                                        )}
                                                    </FloatingLabel>
                                                </div>
                                            </Column>
                                </Row>
                                 <Row>
                                <Column lg={12} md={12} className="section-height">
                                    <Row>
                                        <Column lg={contactInoLg} md={contactInoMd}
                                            className={formValidation['homePhone']?.isValid == false ? 'feedback-row' : ''}>
                                            <div className="input-group has-validation">
                                                <span className="input-group-text remove-right-radius mb-3">
                                                    <Icon icon="home" className="text-muted fa-fw" />
                                                </span>
                                                <FloatingLabel controlId="homePhone"
                                                    label={<>{cstScrLables.HOME_PHONE}</>}
                                                    className="mb-3"
                                                >
                                                    <InputMask
                                                        name="homePhone"
                                                        value={insured.homePhone ?? ""}
                                                        onChange={(event) => onEntityFieldChange('homePhone', event.value)}
                                                        mask={cstScrLables.PHONE_MASK}
                                                        tabIndex={tbindex++}
                                                        placeholder=""
                                                        // required={true}
                                                        invalid={formValidation['homePhone']?.isValid === false}
                                                            />
                                                    <label>{cstScrLables.HOME_PHONE}</label>
                                                    
                                                    {formValidation['homePhone']?.isValid == false && (
                                                        <Form.Control.Feedback type="invalid" style={{ display: 'block' }}>
                                                            {formValidation['homePhone']?.warningText}
                                                        </Form.Control.Feedback>
                                                    )}
                                                </FloatingLabel>
                                            </div>
                                        </Column>
                                        <Column lg={contactInoLg} md={contactInoMd}
                                                className={formValidation['otherPhone1']?.isValid == false ? 'feedback-row' : ''}>
                                                <div className="input-group has-validation">
                                                    <span className="input-group-text remove-right-radius mb-3">
                                                        <Icon icon="building" className="text-muted fa-fw" />
                                                    </span>
                                                    <FloatingLabel controlId="otherPhone1"
                                                        label={<>{cstScrLables.OTHER_PHONE1}</>}
                                                        className="mb-3">
                                                        <InputMask
                                                            name="otherPhone1"
                                                            tabIndex={tbindex++}
                                                            value={insured.otherPhone1 ?? ""}
                                                            onChange={(event) => onEntityFieldChange('otherPhone1', event.value)}
                                                            mask={cstScrLables.PHONE_MASK}
                                                            placeholder=""
                                                            invalid={formValidation['otherPhone1']?.isValid === false} />
                                                        <label>{cstScrLables.OTHER_PHONE1}</label>
                                                        {formValidation['otherPhone1']?.isValid == false && (
                                                            <Form.Control.Feedback type="invalid" style={{ display: 'block' }}>
                                                                {formValidation['otherPhone1']?.warningText}
                                                            </Form.Control.Feedback>
                                                        )}
                                                    </FloatingLabel>
                                                </div>
                                            </Column>
                                        
                                            <Column lg={contactInoLg} md={contactInoMd}
                                                className={formValidation['otherPhone2']?.isValid == false ? 'feedback-row' : ''}>
                                                <div className="input-group has-validation">
                                                    <span className="input-group-text remove-right-radius mb-3">
                                                        <Icon icon="building" className="text-muted fa-fw" />
                                                    </span>
                                                    <FloatingLabel controlId="otherPhone2"
                                                        label={<>{cstScrLables.OTHER_PHONE2}</>}
                                                        className="mb-3">
                                                        <InputMask
                                                            name="otherPhone2"
                                                            tabIndex={tbindex++}
                                                            value={insured.otherPhone2 ?? ""}
                                                            onChange={(event) => onEntityFieldChange('otherPhone2', event.value)}
                                                            mask={cstScrLables.PHONE_MASK}
                                                            placeholder=""
                                                            invalid={formValidation['otherPhone2']?.isValid === false} />
                                                        <label>{cstScrLables.OTHER_PHONE2}</label>
                                                        {formValidation['otherPhone2']?.isValid == false && (
                                                            <Form.Control.Feedback type="invalid" style={{ display: 'block' }}>
                                                                {formValidation['otherPhone2']?.warningText}
                                                            </Form.Control.Feedback>
                                                        )}
                                                    </FloatingLabel>
                                                </div>
                                            </Column>
                                        </Row>
                                        <Row>
                                        <Column lg={contactInoLg} md={contactInoMd}
                                            className={formValidation['workPhone']?.isValid == false ? 'feedback-row' : ''}>
                                            <div className="input-group has-validation">
                                                <span className="input-group-text remove-right-radius mb-3">
                                                    <Icon icon="building" className="text-muted fa-fw" />
                                                </span>
                                                <FloatingLabel controlId="workPhone"
                                                    label={<>{cstScrLables.WORK_PHONE}</>}
                                                    className="mb-3">
                                                    <InputMask
                                                        name="workPhone"
                                                        tabIndex={tbindex++}
                                                        value={insured.workPhone ?? ""}
                                                        onChange={(event) => onEntityFieldChange('workPhone', event.value)}
                                                        mask={cstScrLables.PHONE_MASK}
                                                        placeholder="" 
                                                        invalid={formValidation['workPhone']?.isValid === false}/>
                                                    <label>{cstScrLables.WORK_PHONE}</label>
                                                    {formValidation['workPhone']?.isValid == false && (
                                                        <Form.Control.Feedback type="invalid" style={{ display: 'block' }}>
                                                            {formValidation['workPhone']?.warningText}
                                                        </Form.Control.Feedback>
                                                    )}                                                
                                                </FloatingLabel>
                                            </div>
                                        </Column>
                                         <Column lg={contactInoLg} md={contactInoMd}
                                            className={formValidation['mobile']?.isValid == false ? 'feedback-row' : ''}>
                                            <div className="input-group has-validation">
                                                <span className="input-group-text remove-right-radius mb-3">
                                                    <Icon icon="mobile" className="text-muted fa-fw" />
                                                </span>
                                                <FloatingLabel controlId="mobile"
                                                    label={<>{cstScrLables.MOBILE}</>}
                                                    className="mb-3">
                                                    <InputMask
                                                        name="mobile"
                                                        tabIndex={tbindex++}
                                                        value={insured.mobile ?? ""}
                                                        onChange={(event) => onEntityFieldChange('mobile', event.value)}
                                                        mask={cstScrLables.PHONE_MASK}
                                                        placeholder=""
                                                        invalid={formValidation['mobile']?.isValid === false}
                                                        />
                                                    {formValidation['mobile']?.isValid == false && (
                                                        <Form.Control.Feedback type="invalid" style={{ display: 'block' }}>
                                                            {formValidation['mobile']?.warningText}
                                                        </Form.Control.Feedback>
                                                    )}
                                                </FloatingLabel>
                                            </div>
                                        </Column>
                                    </Row>
                                    </Column>
                                    </Row>
                        </Panel>
                       

                        <Panel title={'Address Information'} className={'customerPanel cstPanel mt-2 customer-edit-policy-pannel'} cardBodyClassName="pt-0" >
                            <Row className='border-top' style={{ paddingTop: "10px" }}>
                                <Column lg={12} md={12} className="section-height customer-edit-policy-column customer-edit-policy-verticalLine">
                                    <div>
                                        <h6 className="text-uppercase">{cstPolicyDetailLabel.MAILING_ADDRESS_CUSTOMER_ADDRESS}</h6>
                                        <Row>
                                            <Column lg={5} md={5}>
                                                <Select
                                                    id="mailCountryCode"
                                                    controlId="mailCountryCode"
                                                    label={cstScrLables.COUNTRY}
                                                    tabIndex={tbindex++}
                                                    options={countries}
                                                    defaultSelected={countries.filter(option =>
                                                        option.countryCode === addressCountry || option.value === addressCountry
                                                    )}
                                                    onChange={(values) => onMailCountrySelection(values[0] as string)}
                                                    className='mb-3'
                                                />
                                            </Column>
                                        </Row>
                                        <Row>
                                            <Column lg={6} md={6}>
                                                <FloatingLabel
                                                    controlId="mailAddr1"
                                                    label={<>
                                                        {cstScrLables.ADDRESS_1}
                                                        <span className="text-danger ms-1">*</span>
                                                    </>}
                                                    className="mb-3"
                                                >
                                                    <Form.Control
                                                        type="text"
                                                        tabIndex={tbindex++}
                                                        placeholder=" "
                                                        name="mailAddr1"
                                                        value={insured.mailAddr1 ?? ""}
                                                        onChange={(event) => onEntityFieldChange('mailAddr1', event.currentTarget.value)}
                                                        maxLength={100}
                                                    />
                                                </FloatingLabel>
                                            </Column>
                                            <Column lg={6} md={6}>
                                                <FloatingLabel
                                                    controlId="mailAddr2"
                                                    label={cstScrLables.ADDRESS_2}
                                                    className="mb-3"
                                                >
                                                    <Form.Control
                                                        type="text"
                                                        tabIndex={tbindex++}
                                                        placeholder=" "
                                                        name="mailAddr2"
                                                        value={insured.mailAddr2 ?? ""}
                                                        onChange={(event) => onEntityFieldChange('mailAddr2', event.currentTarget.value)}
                                                        maxLength={100}
                                                    />
                                                </FloatingLabel>
                                            </Column>
                                        </Row>
                                        <Row>
                                            <Column lg={4} md={4}>
                                                <FloatingLabel
                                                    controlId="mailCity"
                                                    label={cstScrLables.CITY}
                                                    className="mb-3"
                                                >
                                                    <Form.Control
                                                        type="text"
                                                        tabIndex={tbindex++}
                                                        placeholder=" "
                                                        name="mailCity"
                                                        value={insured.mailCity ?? ""}
                                                        onChange={(event) => onEntityFieldChange('mailCity', event.currentTarget.value)}
                                                        maxLength={100}
                                                    />
                                                </FloatingLabel>
                                            </Column>
                                            <Column lg={4} md={4}>
                                                {isMailUSA ?
                                                    <Select
                                                        id="mailState"
                                                        controlId="mailState"
                                                        label={cstScrLables.STATE}
                                                        tabIndex={tbindex++}
                                                        options={states}
                                                        defaultSelected={states.filter(option =>
                                                            option.value === insured.mailState
                                                        )}
                                                        onChange={(values) => onEntityFieldChange('mailState', values[0] as string)}
                                                        isInvalid={formValidation['mailState']?.isValid == false}
                                                        invalidWarning={formValidation['mailState']?.warningText}
                                                        className='mb-3'
                                                    />
                                                    :
                                                    <FloatingLabel
                                                        controlId="mailState"
                                                        label={cstScrLables.STATE}
                                                        className="mb-3"
                                                    >
                                                        <Form.Control
                                                            type="text"
                                                            tabIndex={tbindex++}
                                                            placeholder=" "
                                                            name="mailState"
                                                            value={insured.mailState ?? ""}
                                                            onChange={(event) => onEntityFieldChange('mailState', event.currentTarget.value)}
                                                            maxLength={100}
                                                        />
                                                    </FloatingLabel>
                                                }
                                            </Column>
                                            <Column lg={4} md={4}>
                                                <TextInputWithZipCode
                                                    name="mailZip"
                                                    label={cstScrLables.ZIP}
                                                    controlId="mailZip"
                                                    placeholder="mailZip"
                                                    value={insured.mailZip ?? ""}
                                                    tabIndex={tbindex++}
                                                    onChange={(event) => {
                                                        onEntityFieldChange('mailZip', event.currentTarget.value);
                                                    }}
                                                    onBlur={() => handleChangeZipCodeOnBlur('mailZip', insured.mailZip, isMailUSA)}
                                                    disabled={false}
                                                    maxLength={isMailUSA ? 10 : 9}
                                                    type={"text"}
                                                    isUSA={isMailUSA}
                                                    isInvalid={formValidation['mailZip']?.isValid == false}
                                                    invalidWarning={formValidation['mailZip']?.warningText}
                                                />
                                            </Column>
                                        </Row>
                                        <Row>
                                            <Column lg={6} md={6}>
                                                <FloatingLabel
                                                    controlId="mailCounty"
                                                    label={cstScrLables.COUNTY}
                                                    className="mb-3"
                                                >
                                                    <Form.Control
                                                        type="text"
                                                        tabIndex={tbindex++}
                                                        placeholder=" "
                                                        name="mailCounty"
                                                        value={insured.mailCounty ?? ""}
                                                        onChange={(event) => onEntityFieldChange('mailCounty', event.currentTarget.value)}
                                                        disabled={!isEditable}
                                                        maxLength={100}
                                                    />
                                                </FloatingLabel>
                                            </Column>
                                        </Row>
                                    </div>
                                </Column>
                                <Column lg={12} md={12} className="section-height customer-edit-policy-column customer-edit-policy-verticalLine">
                                    <div>                                      
                                            <h6 className="text-uppercase">{cstPolicyDetailLabel.RESIDENTIAL_ADDRESS}</h6>
                                            <Row>
                                                <Column lg={8} md={8}>
                                                    <FloatingLabel
                                                        controlId="resAddr1"
                                                        label={cstScrLables.ADDRESS_1}
                                                        className="mb-3"
                                                    >
                                                        <Form.Control
                                                            type="text"
                                                            tabIndex={tbindex++}
                                                            placeholder=" "
                                                            name="resAddr1"
                                                            value={insured.resAddr1 ?? ""}
                                                            onChange={(event) => onEntityFieldChange('resAddr1', event.currentTarget.value)}
                                                            maxLength={100}
                                                        />
                                                    </FloatingLabel>
                                                </Column>

                                                <Column lg={4} md={4}>
                                                    <FloatingLabel
                                                        controlId="resAddr2"
                                                        label={cstScrLables.ADDRESS_2}
                                                        className="mb-3"
                                                    >
                                                        <Form.Control
                                                            type="text"
                                                            placeholder=" "
                                                            tabIndex={tbindex++}
                                                            name="resAddr2"
                                                            value={insured.resAddr2 ?? ""}
                                                            onChange={(event) => onEntityFieldChange('resAddr2', event.currentTarget.value)}
                                                            maxLength={100}
                                                        />
                                                    </FloatingLabel>
                                                </Column>
                                            </Row>

                                            {/* Billing Address Line 2 */}
                                            <Row>
                                                <Column lg={5} md={5}>
                                                    <FloatingLabel
                                                        controlId="rescity"
                                                        label={cstScrLables.CITY}
                                                        className="mb-3"
                                                    >
                                                        <Form.Control
                                                            type="text"
                                                            tabIndex={tbindex++}
                                                            placeholder=" "
                                                            name="resCity"
                                                            value={insured.resCity ?? ""}
                                                            onChange={(event) => onEntityFieldChange('resCity', event.currentTarget.value)}
                                                            maxLength={100}
                                                        />
                                                    </FloatingLabel>
                                                </Column>

                                                <Column lg={4} md={4}>
                                                    {isMailUSA ?
                                                            <Select
                                                                id="resState"
                                                                controlId="resState"
                                                                label={cstScrLables.STATE}
                                                                tabIndex={tbindex++}
                                                                options={states}
                                                                defaultSelected={states.filter(option =>
                                                                    option.value === insured.resState
                                                                )}
                                                                onChange={(values) => onEntityFieldChange('resState', values[0] as string)}
                                                                isInvalid={formValidation['resState']?.isValid == false}
                                                                invalidWarning={formValidation['resState']?.warningText}
                                                                className='mb-3'
                                                            />
                                                        :
                                                        <FloatingLabel controlId="resState" label={cstScrLables.STATE} className="mb-3">
                                                            <Form.Control
                                                                type="text"
                                                                tabIndex={tbindex++}
                                                                placeholder=" "
                                                                name="resState"
                                                                value={insured.resState ?? ""}
                                                                onChange={(event) => onEntityFieldChange('resState', event.currentTarget.value)}
                                                                maxLength={2}
                                                            />
                                                        </FloatingLabel>
                                                    }
                                                </Column>

                                            <Column lg={3} md={3}>
                                                <TextInputWithZipCode
                                                    name="resZip"
                                                    label={cstScrLables.ZIP }
                                                    controlId="resZip"
                                                    placeholder="resZip"
                                                    value={insured.resZip ?? ""}
                                                    tabIndex={tbindex++}
                                                    onChange={(event) => {
                                                        onEntityFieldChange('resZip', event.currentTarget.value);
                                                    }}
                                                    onBlur={(e) => handleChangeZipCodeOnBlur('resZip', insured.resZip, isMailUSA)}
                                                    disabled={false}
                                                    maxLength={isMailUSA ? 10 : 9}
                                                    isUSA={isMailUSA}
                                                    type={"text"}
                                                    isInvalid={formValidation['resZip']?.isValid == false}
                                                    invalidWarning={formValidation['resZip']?.warningText}
                                                />
                                            </Column>
                                                 </Row>
                                                <Row>
                                                <Column lg={5} md={5}
                                                className={formValidation['rescounty']?.isValid == false ? 'feedback-row' : ''}>
                                                <FloatingLabel
                                                    controlId="rescounty"
                                                    label={<>
                                                        {cstScrLables.COUNTY}
                                                        {/* <span className="text-danger ms-1">*</span> */}
                                                    </>}
                                                    className="mb-3"
                                                >
                                                    <Form.Control
                                                        type="text"
                                                        placeholder=" "
                                                        name="resCounty"
                                                        value={insured.resCounty ?? ""}
                                                        tabIndex={tbindex++}
                                                        onChange={(event) => onEntityFieldChange('resCounty', event.currentTarget.value)}
                                                        disabled={!isEditable}
                                                        // required
                                                        maxLength={100}
                                                        // isInvalid={formValidation['resCounty']?.isValid == false}
                                                    />
                                                    {/* {formValidation['resCounty']?.isValid == false && (
                                                        <Form.Control.Feedback type="invalid">
                                                            {formValidation['resCounty']?.warningText}
                                                        </Form.Control.Feedback>
                                                    )} */}
                                                </FloatingLabel>
                                            </Column>                                                                                
                                            
                                            
                                        </Row>
                                    </div>
                                </Column>
                                <Column lg={12} md={12} className="section-height customer-edit-policy-column customer-edit-policy-verticalLine">
                                    <div>
                                        <h6 className="text-uppercase">{cstPolicyDetailLabel.PREVIOUS_ADDRESS}</h6>
                                        <Row>
                                            <Column lg={8} md={8}>
                                                <FloatingLabel
                                                    controlId="address1"
                                                    label={cstScrLables.ADDRESS_1}
                                                    className="mb-3"
                                                >
                                                    <Form.Control
                                                        type="text"
                                                        tabIndex={tbindex++}
                                                        placeholder=" "
                                                        name="address1"
                                                        value={previousAddress.address1 ?? ""}
                                                        onChange={(event) => onEntityFieldChangeForPrevAdd('address1', event.currentTarget.value)}
                                                        maxLength={100}
                                                    />
                                                </FloatingLabel>
                                            </Column>

                                            <Column lg={4} md={4}>
                                                <FloatingLabel
                                                    controlId="address2"
                                                    label={cstScrLables.ADDRESS_2}
                                                    className="mb-3"
                                                >
                                                    <Form.Control
                                                        type="text"
                                                        tabIndex={tbindex++}
                                                        placeholder=" "
                                                        name="address2"
                                                        value={previousAddress.address2 ?? ""}
                                                        onChange={(event) => onEntityFieldChangeForPrevAdd('address2', event.currentTarget.value)}
                                                        maxLength={100}
                                                    />
                                                </FloatingLabel>
                                            </Column>
                                        </Row>

                                        <Row>
                                            <Column lg={5} md={5}>
                                                <FloatingLabel
                                                    controlId="city"
                                                    label={cstScrLables.CITY}
                                                    className="mb-3"
                                                >
                                                    <Form.Control
                                                        tabIndex={tbindex++}
                                                        type="text"
                                                        placeholder=" "
                                                        name="city"
                                                        value={previousAddress.city ?? ""}
                                                        onChange={(event) => onEntityFieldChangeForPrevAdd('city', event.currentTarget.value)}
                                                        maxLength={100}
                                                    />
                                                </FloatingLabel>
                                            </Column>

                                            <Column lg={4} md={4}>
                                                {isMailUSA ?
                                                <Select
                                                    id="state"
                                                    controlId="state"
                                                    label={cstScrLables.STATE}
                                                    options={states}
                                                    tabIndex={tbindex++}
                                                    defaultSelected={states.filter(option =>
                                                        option.value === previousAddress.state
                                                    )}
                                                    onChange={(values) => onEntityFieldChangeForPrevAdd('state', values[0] as string)}
                                                    isInvalid={formValidation['state']?.isValid == false}
                                                    invalidWarning={formValidation['state']?.warningText}
                                                    className='mb-3'
                                                />
                                                :
                                                <FloatingLabel controlId="state" label={cstScrLables.STATE} className="mb-3">
                                                    <Form.Control
                                                        type="text"
                                                        tabIndex={tbindex++}
                                                        placeholder=" "
                                                        name="state"
                                                        value={previousAddress.state ?? ""}
                                                        onChange={(event) => onEntityFieldChangeForPrevAdd('state', event.currentTarget.value)}
                                                        maxLength={2}
                                                    />
                                                </FloatingLabel>
                                                }
                                            </Column>
                                            <Column lg={3} md={3}>
                                                <TextInputWithZipCode
                                                    name="zip"
                                                    label={cstScrLables.ZIP}
                                                    controlId="zip"
                                                    placeholder={cstScrLables.ZIP}
                                                    tabIndex={tbindex++}
                                                    value={previousAddress.zip ?? ""}
                                                    onChange={(event) => {
                                                        onEntityFieldChangeForPrevAdd('zip', event.currentTarget.value);
                                                    }}
                                                    onBlur={(e) => handleChangeZipCodeOnBlur('zip', previousAddress.zip, isMailUSA)}
                                                    disabled={false}
                                                    maxLength={isMailUSA ? 10 : 9}
                                                    isUSA={isMailUSA}
                                                    type={"text"}
                                                    isInvalid={formValidation['zip']?.isValid == false}
                                                    invalidWarning={formValidation['zip']?.warningText}
                                                />
                                            </Column>
                                        </Row>
                                        <Row>
                                            <Column lg={5} md={5} className={formValidation['yearsPrevAddress']?.isValid == false ? 'feedback-row' : ''}>
                                                <FloatingLabel
                                                    controlId="yearsPrevAddress"
                                                    label={cstScrLables.YEARATADDRESS}
                                                    className="mb-3">
                                                    <Form.Control
                                                        type="number"
                                                        placeholder=" "
                                                        name="yearsPrevAddress"
                                                        tabIndex={tbindex++}
                                                        value={previousAddress.yearsPrevAddress ?? ""}
                                                        onChange={(event) => {
                                                            const value = Number(event.currentTarget.value);
                                                            if (value <= 100) {
                                                                onEntityFieldChangeForPrevAdd('yearsPrevAddress', value);
                                                            }
                                                        }}
                                                        min={0}
                                                        max={100}
                                                        step={1}
                                                        isInvalid={formValidation['yearsPrevAddress']?.isValid == false}
                                                    />
                                                </FloatingLabel>
                                            </Column>
                                        </Row>
                                    </div>
                                </Column> 
                            </Row>
                        </Panel>
                    </Column>
                    <Column md={4}>

                    </Column>
                </Row>
            </Container>
        </>
    );
};
export default CustomerInsured;

